import type { ComponentProps } from "react";
import * as DropdownMenu from "zeego/dropdown-menu";
import { useTheme } from "~/providers/ThemeProvider";

export const DropdownContent = DropdownMenu.create((props: ComponentProps<typeof DropdownMenu.Content>) => {
    const { colours } = useTheme();

    return (
        <DropdownMenu.Content
            {...props}
            style={{
                backgroundColor: colours.background.secondary,
                borderRadius: 5,
                boxShadow: `1px 3px 3px ${colours.boxShadow}, -1px 0px 3px ${colours.boxShadow}`,
            }}
        />
    );
}, "Content");
